import { render } from "./GraficoGant.vue?vue&type=template&id=6ba7c71e"
import script from "./GraficoGant.vue?vue&type=script&lang=js"
export * from "./GraficoGant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__